import { errorToast, toast } from "@/v2-ui/toast"
import FeatureDetailsHotfixTexts from "@/v2-backoffice-client/feature/details/FeatureDetailsHotfixTexts"
import { useBasemapUpdateMutation } from "@/v2-backoffice-client/basemap/update/basemap.update.mutation"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

export type BasemapViewDetailsHotfixTextsProps = {
  basemap: BasemapFragment
}

/** Binds the shared hotfix text form to the basemap's runtime update. */
function BasemapViewDetailsHotfixTexts(
  props: BasemapViewDetailsHotfixTextsProps,
) {
  const { basemap } = props

  const [updateBasemap, updateState] = useBasemapUpdateMutation()
  errorToast(updateState.error, { title: "Failed to update basemap texts" })

  async function onSave(texts: { name: string; description: string | null }) {
    const result = await updateBasemap({
      variables: {
        input: {
          FeatureCode: basemap.FeatureCode,
          Name: texts.name,
          Description: texts.description,
        },
      },
    })
    if (result.data) {
      toast({ title: "Basemap texts saved to the live runtime." })
    }
  }

  return (
    <FeatureDetailsHotfixTexts
      name={basemap.Name}
      description={basemap.Description ?? ""}
      isSaving={updateState.loading}
      featureCodeLabel="Basemaps"
      onSave={(texts) => void onSave(texts)}
    />
  )
}

export default BasemapViewDetailsHotfixTexts
